import { useFeatureValue } from '@growthbook/growthbook-react'
import { Logger } from '../utils/loggerUtils'
import { CaptchaTokenError } from '../errors/captcha'
const CAPTCHA_TIMEOUT = 10 * 1000

export const useReCaptcha = (onSubmit, action) => {
  const logger = new Logger.Builder()
    .setContext('ReCaptcha')
    .enableSentryIntegration()
    .build()

  const isRecaptchaEnabled = useFeatureValue('is_recaptcha_enabled') === true

  const waitForGrecaptchaReady = () =>
    new Promise((resolve, reject) => {
      const timeout = Date.now() + CAPTCHA_TIMEOUT
      const check = () => {
        if (window.grecaptcha?.enterprise?.ready) {
          window.grecaptcha.enterprise.ready(resolve)
        } else if (Date.now() > timeout) {
          reject(new Error('reCaptcha script never loaded'))
        } else {
          setTimeout(check, 100)
        }
      }
      check()
    })

  return async (params) => {
    try {
      let recaptchaToken = null

      if (isRecaptchaEnabled) {
        await waitForGrecaptchaReady()
        recaptchaToken = await window.grecaptcha.enterprise.execute(
          process.env.GATSBY_RECAPTCHA_KEY,
          { action }
        )
        if (!recaptchaToken) {
          throw new CaptchaTokenError(action, 'reCaptcha')
        }
      }

      return await onSubmit({ ...params, recaptchaToken })
    } catch (err) {
      if (!(err instanceof CaptchaTokenError)) {
        logger.error(err)
      }
      return await onSubmit({ ...params, recaptchaToken: null })
    }
  }
}
